import styled from "styled-components";

export const FooterContainer = styled.div`
  background-color: #0a0a0a;
  font-family: "Thasadith", sans-serif;
  bottom: 0;
  width: 100%;
  height: 1rem;
  font-size: 0.7rem;
  color: white;
`;
